<template>
  <div class="container">
    <h2 class="mb-5">Manage pages</h2>
    <table class="r-table table table-striped">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Title</th>
          <th scope="col" class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, key) in pages" :key="key">
          <th class="font-weight-light">{{key}}</th>
          <th class="font-weight-light">{{item.title}}</th>
          <th class="text-right">
            <span
              class="action-icon"
              @click="$router.push({ name: 'page', params: { pageId: key } })"
              title="Preview page"
            >
              <i class="fas fa-eye"></i>
            </span>
            <span
              class="action-icon"
              @click="$router.push({ name: 'user.pages.edit', params: { pageId: key } })"
              title="Edit page"
            >
              <i class="fas fa-pen"></i>
            </span>
          </th>
        </tr>
      </tbody>
    </table>
    <button
      class="btn btn-info btn-lg btn-block"
      @click="$router.push({ name: 'user.pages.configuration' });"
    >Configuration</button>
    <div class="row mt-4">
      <div class="col-6 text-left">
        <base-button radius="bl" component-class="blue" @click.native="$router.push({ name: 'user.dashboard' })">
          <i class="fas fa-arrow-left mr-3"></i> Back
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseButton from '@/components/inputs/button/BaseButton';
    export default {
        data() {
            return {
                currentPage: {}
            };
        },

        computed: {
            pages() {
                return this.$store.state.app.staticPages;
            }
        },

        mounted() {
            this.$store.dispatch('app/getStaticPages');
        },
        components: {
          'base-button': BaseButton,
        }
    };
</script>
